(function () {
  'use strict';

  var SECTION_SELECTOR = '.wb-aa-section';

  function initSlider(slider) {
    if (!slider || slider.__wbAaInit) return;

    var beforePanel = slider.querySelector('[data-before-panel]');
    var handle = slider.querySelector('[data-handle]');

    if (!beforePanel || !handle) return;

    slider.__wbAaInit = true;

    var isDragging = false;
    var currentPct = 50;

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function applyPosition(pct) {
      currentPct = clamp(pct, 0, 100);

      var hiddenRight = 100 - currentPct;

      beforePanel.style.clipPath = 'inset(0 ' + hiddenRight + '% 0 0)';
      beforePanel.style.webkitClipPath = 'inset(0 ' + hiddenRight + '% 0 0)';
      beforePanel.style.setProperty('--wb-aa-divider-x', currentPct + '%');

      handle.style.left = currentPct + '%';
    }

    function getClientX(event) {
      if (event.touches && event.touches.length) {
        return event.touches[0].clientX;
      }

      if (event.changedTouches && event.changedTouches.length) {
        return event.changedTouches[0].clientX;
      }

      return event.clientX;
    }

    function getPctFromEvent(event) {
      var rect = slider.getBoundingClientRect();
      var clientX = getClientX(event);
      var x = clamp(clientX - rect.left, 0, rect.width);

      if (!rect.width) return currentPct;

      return (x / rect.width) * 100;
    }

    function onStart(event) {
      isDragging = true;
      applyPosition(getPctFromEvent(event));

      if (event.pointerId && slider.setPointerCapture) {
        try {
          slider.setPointerCapture(event.pointerId);
        } catch (error) {}
      }
    }

    function onMove(event) {
      if (!isDragging) return;
      applyPosition(getPctFromEvent(event));
    }

    function onEnd(event) {
      isDragging = false;

      if (event && event.pointerId && slider.releasePointerCapture) {
        try {
          slider.releasePointerCapture(event.pointerId);
        } catch (error) {}
      }
    }

    function onClick(event) {
      applyPosition(getPctFromEvent(event));
    }

    applyPosition(currentPct);

    if (window.PointerEvent) {
      slider.addEventListener('pointerdown', onStart);
      slider.addEventListener('pointermove', onMove);
      slider.addEventListener('pointerup', onEnd);
      slider.addEventListener('pointercancel', onEnd);
      slider.addEventListener('pointerleave', onEnd);
    } else {
      slider.addEventListener('mousedown', onStart);
      slider.addEventListener('mousemove', onMove);
      slider.addEventListener('mouseup', onEnd);
      slider.addEventListener('mouseleave', onEnd);

      slider.addEventListener('touchstart', onStart, { passive: true });
      slider.addEventListener('touchmove', onMove, { passive: true });
      slider.addEventListener('touchend', onEnd);
      slider.addEventListener('touchcancel', onEnd);
    }

    slider.addEventListener('click', onClick);

    slider.__wbAaCleanup = function () {
      if (window.PointerEvent) {
        slider.removeEventListener('pointerdown', onStart);
        slider.removeEventListener('pointermove', onMove);
        slider.removeEventListener('pointerup', onEnd);
        slider.removeEventListener('pointercancel', onEnd);
        slider.removeEventListener('pointerleave', onEnd);
      } else {
        slider.removeEventListener('mousedown', onStart);
        slider.removeEventListener('mousemove', onMove);
        slider.removeEventListener('mouseup', onEnd);
        slider.removeEventListener('mouseleave', onEnd);

        slider.removeEventListener('touchstart', onStart);
        slider.removeEventListener('touchmove', onMove);
        slider.removeEventListener('touchend', onEnd);
        slider.removeEventListener('touchcancel', onEnd);
      }

      slider.removeEventListener('click', onClick);

      slider.__wbAaInit = false;
      slider.__wbAaCleanup = null;
    };
  }

  function initSection(section) {
    if (!section) return;

    section.querySelectorAll('[data-slider]').forEach(function (slider) {
      initSlider(slider);
    });
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector(SECTION_SELECTOR);

    if (!section && event.target.matches && event.target.matches(SECTION_SELECTOR)) {
      section = event.target;
    }

    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector(SECTION_SELECTOR);

    if (!section && event.target.matches && event.target.matches(SECTION_SELECTOR)) {
      section = event.target;
    }

    if (!section) return;

    section.querySelectorAll('[data-slider]').forEach(function (slider) {
      if (slider.__wbAaCleanup) slider.__wbAaCleanup();
    });
  });
})();